import { useAnalyticSession } from "@octopusdeploy/portal-analytics";
import type { ArgoCDFields } from "~/analytics/AnalyticSession";
import type { ArgoCDEventDispatcher } from "~/analytics/Analytics";
export function useArgoCDEventDispatcher(gatewayName: string | undefined, spaceId: string | undefined, correlationId: string): ArgoCDEventDispatcher {
    const session = useAnalyticSession();
    return (name: string) => {
        const fields: ArgoCDFields = {
            "Correlation Id": correlationId,
        };
        if (gatewayName) {
            fields["Gateway Name"] = session.anonymize(gatewayName);
        }
        if (spaceId) {
            fields["Space Id"] = session.anonymize(spaceId);
        }
        if (gatewayName && spaceId) {
            fields["Unique Identifier"] = session.anonymize(`${spaceId}-${gatewayName}`);
        }
        session.track(name, fields);
    };
}
